module.exports = __webpack_public_path__ + "media/images/ui__arrowDownInactive-05cd5a0e5c0f898032e584317d561f3d.png";